import React, { ReactNode } from 'react';
export const adminInputClass = 'w-full rounded-sm border border-pine/25 bg-white px-3.5 py-2.5 text-pine placeholder:text-clay/40 transition-colors focus:border-pine focus:outline-none focus:ring-2 focus:ring-pine/15 disabled:bg-creamDeep disabled:text-clay/60';
interface AdminFieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: ReactNode;
  className?: string;
}
export function AdminField({
  label,
  htmlFor,
  required = false,
  hint,
  error,
  children,
  className = ''
}: AdminFieldProps) {
  return <div className={className} data-id="element-39" data-mp="varccn2uhtge">
      <label htmlFor={htmlFor} className="mb-1.5 block text-sm font-medium text-pine" data-id="element-40" data-mp="vckje3hdefox">
        {label}
        {required && <span className="ml-1 text-ember" data-id="element-41" data-mp="109kp2dab5gfi">*</span>}
      </label>
      {children}
      {error ? <p id={`${htmlFor}-error`} className="mt-1.5 text-sm text-ember" role="alert" data-id="element-42" data-mp="2x4gs75c5lbg0">
          {error}
        </p> : hint && <p className="mt-1.5 text-xs text-clay/70" data-id="element-43" data-mp="kxkhbff6l25l">{hint}</p>}
    </div>;
}